const TIME_UNITS = {
  days: [
    'PaymentLinks | timeUnits.days[0]',
    'PaymentLinks | timeUnits.days[1]',
    'PaymentLinks | timeUnits.days[2]',
  ],
  hours: [
    'PaymentLinks | timeUnits.hours[0]',
    'PaymentLinks | timeUnits.hours[1]',
    'PaymentLinks | timeUnits.hours[2]',
  ],
  minutes: [
    'PaymentLinks | timeUnits.minutes[0]',
    'PaymentLinks | timeUnits.minutes[1]',
    'PaymentLinks | timeUnits.minutes[2]',
  ],
  seconds: [
    'PaymentLinks | timeUnits.seconds[0]',
    'PaymentLinks | timeUnits.seconds[1]',
    'PaymentLinks | timeUnits.seconds[2]',
  ],
}

export { TIME_UNITS }
